import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import authReducer from './Auth/AuthSlice';
import categoryReducer from './Category/CategorySlice';
import areaOfLawReducer from './AreaOfLaw/AreaOfLawSlice';
import folderReducer from './FolderSlice';
import favoriteReducer from './FavoriteSlice';

const persistConfig = {
  key: 'docarn-root',
  storage,
  whitelist: ['auth', 'category', 'areaOfLaw', 'folders', 'favorites']
};

const rootReducer = combineReducers({
  category: categoryReducer,
  areaOfLaw: areaOfLawReducer,
  auth: authReducer,
  folders: folderReducer,
  favorites: favoriteReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const Store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(Store);
export default Store;
export type RootState = ReturnType<typeof Store.getState>;
export type AppDispatch = typeof Store.dispatch;
